import { en, type MessageKey } from './en'
import { hi } from './hi'
import type { Locale } from '@/lib/ist'
import { applyPlurals } from './plural'

export type { MessageKey, Locale }

export const dictionaries: Record<Locale, Record<MessageKey, string>> = { en, hi }

export type MessageVars = Record<string, string | number>

let current: Locale = 'hi'
/** The language on screen now (kept by I18nProvider), for code that reads text outside React context. */
export const currentLocale = (): Locale => current
export function setCurrentLocale(locale: Locale) {
  current = locale
}

/**
 * Look up and interpolate `{name}` placeholders, and `{name:one|other}` plural forms chosen by
 * the number in `name`. Missing keys fall back to English, then the key.
 */
export function translate(locale: Locale, key: MessageKey, vars?: MessageVars): string {
  const template = dictionaries[locale][key] ?? en[key] ?? key
  if (!vars) return template
  // A Hindi message falling back to English is pluralised by English rules.
  const pluralLocale = dictionaries[locale][key] ? locale : 'en'
  return applyPlurals(pluralLocale, template, vars).replace(/\{(\w+)\}/g, (match, name: string) =>
    name in vars ? String(vars[name]) : match,
  )
}
